import { config } from '_config';

export const createOAuthUrl = (data) => {
  return `${data?.message}&redirect_uri=${window.location.origin}${config.publicUrl}/oauth/callback`;
};
